import React from 'react';
import { BrainIcon } from 'lucide-react';
type PlayerTabsProps = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};
const PlayerTabs = ({
  activeTab,
  setActiveTab
}: PlayerTabsProps) => {
  const tabs = [{
    id: 'stats',
    label: 'STATS'
  }, {
    id: 'tki',
    label: 'TKI'
  }, {
    id: 'neuro',
    label: <div className="flex items-center gap-1.5" data-id="element-659" data-mp="24lqzl9seppf2">
          <BrainIcon className="w-4 h-4" data-id="element-660" data-mp="28khowuqms2rm" />
          NEURO
        </div>
  }, {
    id: 'charts',
    label: 'CHARTS'
  }, {
    id: 'trends',
    label: 'TRENDS'
  }, {
    id: 'box_score',
    label: 'BOX SCORE'
  }, {
    id: 'timeline',
    label: 'TIMELINE'
  }, {
    id: 'matches',
    label: 'MATCHES'
  }, {
    id: 'team_mates',
    label: 'TEAMMATES'
  }, {
    id: 'notes',
    label: 'NOTES'
  }, {
    id: 'career',
    label: 'CAREERS'
  }];
  return <div className="mt-6 border-b" data-id="element-661" data-mp="1ih50fwu2v47q">
      <div className="flex" data-id="element-662" data-mp="1ii6nz0sa5j6c">
        {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-2 text-sm font-medium ${activeTab === tab.id ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-663" data-mp="1dqyey5uv3ztp">
            {tab.label}
          </button>)}
      </div>
    </div>;
};
export default PlayerTabs;